import { useSelector } from 'react-redux';
import { RescueBundleSkus, rescuePlan } from '../lib/rescueCheckout';
import * as types from '../types';
import useSubscriptionProducts from './useSubscriptionProducts';

/** The Mini and plan SKUs of the adoption bundle; either is undefined until products load. */
export default function useRescueBundleSkus(): RescueBundleSkus {
  const products = useSelector((state: types.AppState) => state.config.products);
  const miniPlusByDefault = useSelector((state: types.AppState) => !!state.config.siteConfig.miniPlusByDefault);
  const planSku = rescuePlan(useSubscriptionProducts(types.miniCollarId), miniPlusByDefault)?.sku;
  const miniSku = (products.find((p) => p.category === types.ProductCategory.MINI) as types.IMiniProduct | undefined)
    ?.sku;

  return { miniSku, planSku };
}
